import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GenericsService } from './generics.service';
import { LoginService } from './login.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Bearer OTA2ZmFlM2Y3MWZiZmM1ZmRhMWEzYThmODdiNzU4ODE='
  })
};

@Injectable({
  providedIn: 'root'
})
export class Membros {
  id:number;
  emailMembro:string;
  perfilMembro:string;
}

@Injectable({
  providedIn: 'root'
})
export class Projeto {
  public descricao:string;
  public tipoProjeto:string;
  public dataInicio:Date;
  public dataPrevisaoTermino:Date;

  constructor(desc:string, tipoProj:string, dataini:Date, dataPrev:Date) {
    this.descricao           = desc;
    this.tipoProjeto         = tipoProj;
    this.dataInicio          = dataini;
    this.dataPrevisaoTermino = dataPrev;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProjetosService {

  private projeto:any;

  constructor(private generics: GenericsService,
              private loginServ: LoginService,
              private http: HttpClient) { }

  cadastrarProjeto(form:any) {
    //console.log(JSON.stringify(form), this.generics.getURI() + 'projeto');
    
    if (form.id == null) {
      delete form.id;
      return this.generics.post('projeto', JSON.stringify(form));
    }
    else {
      let id = form.id;
      delete form.id;
      return this.generics.put('projeto/' + id, JSON.stringify(form));
    }
  }

  cadastrarMembro(projeto:any, form:any) {
    console.log(JSON.stringify(form), this.generics.getURI() + 'projeto/' + projeto + '/membros');
    return this.generics.post('projeto/' + projeto + '/membros', JSON.stringify(form));
  }

  encerrarProjeto(id, projeto) {
    return this.generics.post('projeto/' + id + "/encerramento", JSON.stringify(projeto));
  }

  excluirProjeto(projeto) {
    return this.generics.delete('projeto/' + projeto);
  }

  listarProjetos() {
    return this.generics.get('projeto?usuario=' + this.loginServ.getUsuario("id"));
  }

  getProjeto(id) {
    return this.generics.get('projeto/' + id + '?usuario=' + this.loginServ.getUsuario("id"));
  }

  setProjeto(proj:any) {
    this.projeto = proj;
    localStorage.setItem("cadastro_projeto", JSON.stringify(this.projeto));
  }

  removerMembroProjeto(projeto, idMembro) {
    return this.generics.delete('projeto/' + projeto + '/membro/' + idMembro);
  }
}
